import React from 'react';

export const SvgRedo = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.8585 7C18.3062 7 17.8585 7.44772 17.8585 8V13.2827H12.5758C12.0235 13.2827 11.5758 13.7305 11.5758 14.2827C11.5758 14.835 12.0235 15.2827 12.5758 15.2827H18.8585C19.4108 15.2827 19.8585 14.835 19.8585 14.2827V8C19.8585 7.44772 19.4108 7 18.8585 7Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.0684 10.158C13.8715 10.158 16.2659 11.9187 17.2013 14.3979C17.3963 14.9146 17.9732 15.1755 18.4899 14.9805C19.0067 14.7855 19.2675 14.2086 19.0726 13.6919C17.8531 10.4596 14.7308 8.15805 11.0684 8.15805C7.40605 8.15805 4.28376 10.4596 3.06427 13.6919C2.86931 14.2086 3.13016 14.7855 3.64689 14.9805C4.16362 15.1755 4.74056 14.9146 4.93551 14.3979C5.87088 11.9187 8.26529 10.158 11.0684 10.158Z"
      fill="currentColor"
    />
  </svg>
);
